import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-page-loader',
    templateUrl: './page-loader.component.html',
    styleUrls: ['./page-loader.component.css'],
    standalone: false
})
export class PageLoaderComponent implements OnInit, OnDestroy, OnChanges {

  constructor() { }

  ngOnInit() {
    this.hideWindowScrollbar(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showLoader']) {
      this.hideWindowScrollbar(changes['showLoader'].currentValue);
      if (changes['showLoader'].currentValue) {
        this.insertRandomTips();
        this.changeMessage();
      } else if (this.timer) {
        clearInterval(this.timer);
      }
    }
  }

  private hideWindowScrollbar(shouldHide: boolean) {
    if (shouldHide) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
   }

  randomTips: string[] = [
    "Did you know: Creating dashboard views can give you a quick view of your workload?",
    "Tip: When searching for dispatches, selecting 'Open' improves search speed",
    "Tech Tip: Before starting any work, pause to identify potential hazards in your surroundings.",
    "Missing Access? Visit Human Resources > Employee Maint to update your permissions",
    "Reminder: Don't forget to Clock In/Out for the day",
    "Tech Tip: Hitting the road? Ensure your camera lenses, mirrors and sensors are clean",
    "Looking for historical data? Check out all the Reports available",
  ];

  @Input() messages: string[] = [
    "Initializing user interface...",
    "Fetching data...",
    "Optimizing content...",
    "Ensuring security protocols...",
    "Finalizing setup...",
    "Ready to go! Launching...",
  ];

  @Input() showMessages: boolean = false;

  @Input() showLoader: boolean = false;

  @Input() showMessageTimeout: number = 4000;

  currentMessage: string = "";
  finalMessages: string[] = [];
  messageIndex: number = 0;
  timer: any;

  private insertRandomTips() {
    const tipsCopy = [...this.randomTips];
    this.finalMessages = [];
    for (const message of this.messages) {
      this.finalMessages.push(message);
      const numberOfTipsToInsert = Math.random() < 0.5 ? 1 : 2;
      for (let i = 0; i < numberOfTipsToInsert; i++) {
        if (tipsCopy.length > 0) {
          const randomIndex = Math.floor(Math.random() * tipsCopy.length);
          const randomTip = tipsCopy.splice(randomIndex, 1)[0];
          this.finalMessages.push(randomTip);
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.hideWindowScrollbar(false);
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  changeMessage() {
    this.timer = setInterval(() => {
      this.currentMessage = this.finalMessages[this.messageIndex];
      this.messageIndex = (this.messageIndex + 1) % this.finalMessages.length;
      if (0 === this.messageIndex) {
        clearInterval(this.timer);
      }
    }, this.showMessageTimeout);
  }
}
